export const QUERY_ROOT = 'agentforge' as const;

export const sessionsKey = (agentId?: string) =>
  agentId
    ? ([QUERY_ROOT, 'sessions', { agentId }] as const)
    : ([QUERY_ROOT, 'sessions'] as const);

export const messagesKey = (sessionId: string) =>
  [QUERY_ROOT, 'sessions', sessionId, 'messages'] as const;

export const turnStatusKey = (
  sessionId: string,
  turnId?: string,
  identityMode?: string
) =>
  [
    QUERY_ROOT,
    'sessions',
    sessionId,
    'turn-status',
    ...(turnId ? [turnId] : []),
    ...(identityMode ? [identityMode] : []),
  ] as const;
